// *** Allows to overwriteCustomeAssignments chart opts and colors and ... ***
//
import { CUSTOM_CHART_COLORS, CUSTOM_CHART_OPTS } from './colors'
import { overwriteCustomAssignments } from './custom_assignments'

export function overwriteColors() {
  var opts = {
    watermark: false
  }

  var colors = {
    primary: '#00487B',
    primaryDt: '#8DC474',
    colormaps: {
      fromGridToPrimary: [
        '#6B7D8B',
        '#607889',
        '#567288',
        '#4B6D86',
        '#406885',
        '#366383',
        '#2B5D81',
        '#205880',
        '#15537E',
        '#0B4D7D',
        '#00487B'
      ],
      fromGridToPrimaryDt: [
        '#6B7D8B',
        '#6E847F',
        '#6E847F',
        '#718B73',
        '#749268',
        '#77995C',
        '#7AA150',
        '#7DA845',
        '#80AF39',
        '#83B62D',
        '#8DC474'
      ]
    },
    dashboard: {
      toGrid: '#00487B',
      toGridDt: '#8DC474',
      fromGrid: '#6B7D8B',
      fromGridDt: '#8DC474',
      backgroundColorShowNodeTrue: '#00487B',
      backgroundColorShowNodeTrueDt: '#8DC474',
      nodeColor: '#00487B',
      nodeColorDt: '#8DC474',
      lineColors: {
        default: '#6B7D8B',
        defaultDt: '#6B7D8B'
      }
    }
  }

  overwriteCustomAssignments(opts, CUSTOM_CHART_OPTS)
  overwriteCustomAssignments(colors, CUSTOM_CHART_COLORS)
}
